/* All-or-nothing batch toggle: if any id from `batchIds` is already selected,
 * deselect every id in the batch; otherwise add every id in the batch to the
 * selection. Used by row-level "select group children" actions where the user
 * expects a single click to flip the whole batch. */
export const toggleIdBatchInSelection = (
  currentIds: string[],
  batchIds: string[]
): string[] => {
  const incoming: Set<string> = new Set(batchIds);

  const anyAlreadySelected: boolean = currentIds.some((id: string) =>
    incoming.has(id)
  );

  if (anyAlreadySelected) {
    const remaining: string[] = currentIds.filter(
      (id: string) => !incoming.has(id)
    );
    return remaining;
  }

  const merged: Set<string> = new Set(currentIds);
  batchIds.forEach((id: string) => merged.add(id));

  const mergedList: string[] = Array.from(merged);
  return mergedList;
};
